import PropTypes from "prop-types";

import { FlagComponent } from "@/components/ui/phone-input";
import countryOptions from "components/Countries";
import { ISO3TO2 } from "constants/countries";

import FormCombobox from "./FormCombobox";

const renderCountry = option => (
  <span className="tw:flex tw:items-center tw:gap-2">
    <FlagComponent country={ISO3TO2[option.value]} countryName={option.text} />
    {option.text}
  </span>
);

/**
 * A country picker that shows each country's flag. The value is the ISO
 * 3166-1 alpha-3 code the API stores. `options` defaults to every country and
 * takes the same `{ value, text }` shape, for a narrower list such as the
 * countries of a region.
 */
const FormCountrySelect = ({
  options = countryOptions,
  placeholder = "Pick a Country",
  ...props
}) => (
  <FormCombobox
    {...props}
    options={options}
    placeholder={placeholder}
    renderOption={renderCountry}
    renderValue={renderCountry}
  />
);

FormCountrySelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onValueChange: PropTypes.func,
};

export default FormCountrySelect;
